import { createSlice, createAction } from "@reduxjs/toolkit";
import Payment from "../models/Payment";
import { UUID } from "../utils";
import listFactory from "./listFactory";

const { slicePart, selectors } = listFactory<Payment>("transactions");

const initialState = {
  ...slicePart.initialState,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    ...slicePart.reducers,
  },
});

export const { setPaginatedList, setItem, removeList } = slice.actions;

export const fetchTransactions = createAction<{}>("fetchTransactions");
export const fetchTransaction = createAction<{ id: UUID }, "fetchTransaction">(
  "fetchTransaction"
);

export const {
  selectItem: selectPayment,
  selectPaginatedList: selectListData,
} = selectors;

export default slice.reducer;
